export default __webpack_public_path__ + "static/media/power_grey.53e17637.svg";